export const configuracion = {
    apiProtocol: import.meta.env.VITE_API_PROTOCOL || window.API_PROTOCOL,
    apiDomain: import.meta.env.VITE_API_DOMAIN || window.API_DOMAIN,
    apiVersion: import.meta.env.VITE_API_VERSION || window.API_VERSION,
    apiTimeout: import.meta.env.VITE_API_TIMEOUT
        ? Number(import.meta.env.VITE_API_TIMEOUT)
        : window.API_TIMEOUT,
    mercadoPagoPublicKey: import.meta.env.VITE_MERCADOPAGO_PUBLIC_KEY || "",
};

export const getApiUrl = () =>
    `${configuracion.apiProtocol}://${configuracion.apiDomain}/${configuracion.apiVersion}/`;
